import { passwordConstants } from "../_constants";
import { passwordService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const passwordActions = {
  sendRecoveryEmail,

  setPassword,
  setPasswordWithToken
};

function sendRecoveryEmail(email) {
  return dispatch => {
    dispatch(request());

    passwordService.sendRecoveryEmail(email).then(
      detail => {
        dispatch(success(detail, email));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: passwordConstants.RECOVERY_EMAIL_SUBMIT_REQUEST };
  }
  function success(detail, email) {
    return {
      type: passwordConstants.RECOVERY_EMAIL_SUBMIT_SUCCESS,
      detail,
      email
    };
  }
  function failure(error) {
    return { type: passwordConstants.RECOVERY_EMAIL_SUBMIT_FAILURE, error };
  }
}

function setPassword(oldPassword, newPassword, csrf) {
  return dispatch => {
    dispatch(request());

    passwordService.setPassword(oldPassword, newPassword, csrf).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: passwordConstants.SET_PASSWORD_SUBMIT_REQUEST };
  }
  function success(detail) {
    return { type: passwordConstants.SET_PASSWORD_SUBMIT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: passwordConstants.SET_PASSWORD_SUBMIT_FAILURE, error };
  }
}

function setPasswordWithToken(token, newPassword) {
  return dispatch => {
    dispatch(request());

    passwordService.setPasswordWithToken(token, newPassword).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_REQUEST };
  }
  function success(detail) {
    return {
      type: passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_SUCCESS,
      detail
    };
  }
  function failure(error) {
    return {
      type: passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_FAILURE,
      error
    };
  }
}
